import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from '../../utils/navigation';
import { BASE_URL } from '../../constants';
import CallbackComponent from './callbackComponent';

class CallbackPage extends React.Component {
    successCallback = (user) => {
        this.handleRedirect(user);
    };

    handleRedirect = user => {
       if(user.state && !user.state.includes('callback')){
                this.props.dispatch(push(user.state));
        } else {
            this.props.dispatch(push(`${BASE_URL}/`));
        }
    }

    render() {
        // just redirect to '/' in both cases
        return (
            !this.props.apiConfig.clientId ?
            <div>
                  Redirecting... otherwise <a href="#" onClick={(e) => {
                    e.preventDefault();
                    this.props.dispatch(push(`${BASE_URL}/`));
                }}>click here</a>
                </div>
                :
            <CallbackComponent successCallback={this.successCallback} errorCallback={this.successCallback} apiConfig={this.props.apiConfig}>
                 <div>
                  Redirecting... otherwise <a href="#" onClick={(e) => {
                    e.preventDefault();
                    this.props.dispatch(push(`${BASE_URL}/`));
                }}>click here</a>
                </div>
            </CallbackComponent >
        );
    }
}

CallbackPage.propTypes = {
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state){
    return {
        apiConfig: state.apiConfig,
      };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CallbackPage);
